<template>
    <el-dialog class="el-dialogs" :title="title" width="500px" :close-on-click-modal="false" :visible.sync="visible">
        <div>很抱歉，如下 {{ noData.length }} 条资源暂时无法借阅。可能原因为：</div>
        <div class="contentData">
            <div class="minTilte">共 {{ noData.length }} 条：</div>
            <div v-for="item in noData" :key="item.id" class="flex_b_c contentDataSea">
                <div class="contentDataSeaName omit">{{ item.jsonData.mingcheng }}</div>
                <div class="contentDataSeaType">{{ item.statueName }}</div>
            </div>
        </div>
        <div slot="footer" class="text_right">
            <el-button size="small" @click="reselect()">重新选择</el-button>
            <el-button size="small" type="primary" @click="goOnBorrowing()">继续借阅</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "scopeHint",
    data() {
        return {
            title: '',
            visible: false,
            noData:[],
            typeName:'',
        }
    },

    methods: {
        init(typeName,noData) {
            this.noData = noData
            this.typeName = typeName
            if (typeName == 'borrowing') {
                this.title = '资源借阅提示'
            }else {
                this.title = '加入借阅单提示'
            }
            this.visible = true
        },

        //重新选择
        reselect(){
            this.$emit('reselect')
            this.visible = false
        },

        //继续 此时需要筛选不能处理的数据
        goOnBorrowing(){
            this.$emit('goOnBorrowing',this.typeName)
            this.visible = false
        },
    },
}
</script>

<style scoped>
.contentData{
    margin-top: 10px;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    padding: 15px;
    background: #F2F2F2;
}

.minTilte{
    margin-bottom: 5px;
}

.contentDataSea{
    font-size: 12px;
}

.contentDataSeaName{
    flex: 1;
}

.contentDataSeaType{
    width: 120px;
    padding-left: 15px;
    color: #1e88e5;
}
</style>